import Vue from 'vue';
import router from '@/router';
import VueAnalytics from 'vue-analytics';


const isProduction = process.env.NODE_ENV === 'production';

Vue.use(VueAnalytics, {
  id: process.env.VUE_APP_GOOGLE_ANALYTICS_ID,
  router,
  debug: {
    enabled: !isProduction,
    sendHitTask: isProduction,
  },
});
